import { DuplicateHeaderError } from 'utils/error';

export default (contactsCSV) => {
  const headers = [];
  for (let i = 0; i < 2; i += 1) {
    for (let j = 0; j < contactsCSV[i].length; j += 1) {
      if (i === 0 && contactsCSV[i][j]) {
        if (headers.find(o => o.header === contactsCSV[i][j])) {
          throw new DuplicateHeaderError(`${contactsCSV[i][j]}`);
        } else {
          headers.push({ header: contactsCSV[i][j] });
        }
      } else if (headers[j]) {
        headers[j].sample_entry_value = contactsCSV[i][j];
      }
    }
  }
  return headers;
};
